import FavoriteIcon from "@mui/icons-material/Favorite";
import classes from "./Footer.module.scss";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <>
            <p className={classes.footerText}>
                &copy; {currentYear} MAX Aspire. Crafted with{" "}
                <FavoriteIcon className={classes.heartIcon} /> by MAX Aspire
            </p>
        </>
    );
};

export default Footer;
